import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = { class: "panel span-2" }
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "panel" }

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import { ApiError } from '@/core/http/ApiError';
import { MeUpdate, useMe } from '@/modules/user/Me';
import { ErrorBag, handleFormError } from '@/core/common';
import { getAllLanguages, Language } from '@/modules/parameters/Language';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const resource = useMe();
const languages = ref<Language[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<MeUpdate>>({});
const user = computed(() => store.state.authenticatedUser);

onMounted(async () => {
	data.value = Object.assign({}, user.value);
	languages.value = await getAllLanguages();
});

const save = async () => {
	if (!user.value) {
		return;
	}

	errors.value = {};

	const postBody: MeUpdate = Object.assign({}, data.value) as MeUpdate;
	delete postBody.permissions;

	if (typeof postBody.password !== 'undefined' && postBody.password === '') {
		delete postBody.password;
		delete postBody.current_password;
	}

	try {
		const updatedUser = await resource.update(postBody);
		data.value = Object.assign({}, updatedUser);

		store.commit('setAuthenticatedUser', updatedUser);
		Flash.success($gettext('Dina kontouppgifter har uppdaterats!'));

	} catch (e) {
		if (e instanceof ApiError && e.response.status === 403) {
			return Flash.danger(e.message);
		}

		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Min profil'),
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, _createSlots({
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (user.value !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                  _createTextVNode("Din information")
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(AppFormGroup, {
                  id: "user_name",
                  errors: errors.value.name,
                  label: _unref($gettext)('Namn')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      id: "user_name",
                      modelValue: data.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.name) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"]),
                _createVNode(AppFormGroup, {
                  id: "user_email",
                  errors: errors.value.email,
                  label: _unref($gettext)('E-post')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      type: "email",
                      id: "user_email",
                      modelValue: data.value.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.email) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"]),
                _createVNode(AppFormGroup, {
                  id: "user_language",
                  errors: errors.value.language,
                  label: _unref($gettext)('Språk')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppSelect, {
                      id: "user_language",
                      modelValue: data.value.language,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.language) = $event)),
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_3, [
                          _createTextVNode("(Välj)")
                        ])), [
                          [_directive_translate]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: language.id,
                            value: language.id
                          }, _toDisplayString(language.name), 9, _hoisted_4))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                  _createTextVNode("Inloggning")
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(AppFormGroup, {
                  id: "user_password",
                  errors: errors.value.password,
                  label: _unref($gettext)('Nytt lösenord')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      type: "password",
                      id: "user_password",
                      modelValue: data.value.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.password) = $event)),
                      placeholder: "********"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"]),
                _createVNode(AppFormGroup, {
                  id: "user_current_password",
                  errors: errors.value.current_password,
                  label: _unref($gettext)('Ditt nuvarande lösenord')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      type: "password",
                      id: "user_current_password",
                      modelValue: data.value.current_password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.current_password) = $event)),
                      placeholder: "********"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title", "onSubmit"]))
}
}

})